import { SITE_URL } from "@/lib/seo";

// Vídeo de apresentação da Clara (YouTube), usado na home e em /sobre.
export const CLARA_VIDEO_ID = "Cl5BqI_sk7U";

/** Schema VideoObject para a página em que o vídeo aparece. */
export const claraVideoJsonLd = (pageUrl: string) => ({
  "@context": "https://schema.org",
  "@type": "VideoObject",
  name: "Nutrição prática na Austrália: acompanhamento para emagrecer, ter energia e constância",
  description:
    "Clara Camille, nutricionista e imigrante na Austrália, conta como funciona o acompanhamento nutricional em português para quem sente que a alimentação saiu do controle depois de mudar de país.",
  thumbnailUrl: [`https://i.ytimg.com/vi/${CLARA_VIDEO_ID}/hqdefault.jpg`],
  uploadDate: "2026-02-08",
  duration: "PT2M41S",
  embedUrl: `https://www.youtube-nocookie.com/embed/${CLARA_VIDEO_ID}`,
  contentUrl: `https://www.youtube.com/watch?v=${CLARA_VIDEO_ID}`,
  inLanguage: "pt-BR",
  author: { "@type": "Person", name: "Clara Camille", url: `${SITE_URL}/sobre` },
  publisher: { "@id": `${SITE_URL}/#business` },
  mainEntityOfPage: pageUrl,
});
